var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { plainToInstance, Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { PatientDataVisualizationLiteDto, PatientDataVisualizationPdfStatus } from "./patient.data.visualization.dtos";
import { ContactMethod } from "./consentconfig.dtos";
import { DocumentDeliveryDto } from "./document.delivery.dtos";
import { OmitType } from "@nestjs/mapped-types";
export var DocumentVectorizationStatus;
(function (DocumentVectorizationStatus) {
    DocumentVectorizationStatus["NOT_STARTED"] = "NOT_STARTED";
    DocumentVectorizationStatus["PENDING"] = "PENDING";
    DocumentVectorizationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DocumentVectorizationStatus["COMPLETE"] = "COMPLETE";
    DocumentVectorizationStatus["FAILED"] = "FAILED";
})(DocumentVectorizationStatus || (DocumentVectorizationStatus = {}));
export var DocumentRetrievalOrigin;
(function (DocumentRetrievalOrigin) {
    DocumentRetrievalOrigin["PATIENT"] = "PATIENT";
    DocumentRetrievalOrigin["ORGANIZATION"] = "ORGANIZATION";
    DocumentRetrievalOrigin["TESTING"] = "TESTING";
    DocumentRetrievalOrigin["UNKNOWN"] = "UNKNOWN";
})(DocumentRetrievalOrigin || (DocumentRetrievalOrigin = {}));
export var DocumentRetrievalFailureReason;
(function (DocumentRetrievalFailureReason) {
    DocumentRetrievalFailureReason["INVALID_IAL2_TOKEN"] = "DOCUMENT_RETRIEVAL_INVALID_IAL2_TOKEN";
    DocumentRetrievalFailureReason["MED_ALLIES_ADD_PATIENT"] = "DOCUMENT_RETRIEVAL_MED_ALLIES_ADD_PATIENT_ERROR";
    DocumentRetrievalFailureReason["MED_ALLIES_GET_DOCUMENTS"] = "DOCUMENT_RETRIEVAL_MED_ALLIES_GET_DOCUMENTS_ERROR";
    DocumentRetrievalFailureReason["MED_ALLIES_GET_ENDPOINTS"] = "DOCUMENT_RETRIEVAL_MED_ALLIES_GET_ENDPOINTS_ERROR";
    DocumentRetrievalFailureReason["COMMONWELL_ADD_PATIENT"] = "DOCUMENT_RETRIEVAL_COMMONWELL_ADD_PATIENT_ERROR";
    DocumentRetrievalFailureReason["COMMONWELL_GET_DOCUMENTS"] = "DOCUMENT_RETRIEVAL_COMMONWELL_GET_DOCUMENTS_ERROR";
    DocumentRetrievalFailureReason["TIMEOUT"] = "DOCUMENT_RETRIEVAL_TIMEOUT";
    DocumentRetrievalFailureReason["GENERIC_ERROR"] = "DOCUMENT_RETRIEVAL_GENERIC_ERROR";
    DocumentRetrievalFailureReason["SKIPPED_TEFCA_CALLS"] = "DOCUMENT_RETRIEVAL_SKIPPED_TEFCA_CALLS";
    DocumentRetrievalFailureReason["MAX_RETRIES_REACHED"] = "DOCUMENT_RETRIEVAL_MAX_RETRIES_REACHED";
    DocumentRetrievalFailureReason["CLEAR_VALIDATION_FAILED"] = "DOCUMENT_RETRIEVAL_CLEAR_VALIDATION_FAILED";
})(DocumentRetrievalFailureReason || (DocumentRetrievalFailureReason = {}));
export class DocumentRetrievalTaskBatchInput {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchInput.prototype, "batchId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], DocumentRetrievalTaskBatchInput.prototype, "documentSelectionComplete", void 0);
export class PatientInitiatedRetrieveDataInput {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientInitiatedRetrieveDataInput.prototype, "studyId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], PatientInitiatedRetrieveDataInput.prototype, "useTefca", void 0);
export var DataRetrievalFailureReason;
(function (DataRetrievalFailureReason) {
    DataRetrievalFailureReason["GENERIC_ERROR"] = "GENERIC_ERROR";
    DataRetrievalFailureReason["PATIENT_NOT_FOUND"] = "PATIENT_NOT_FOUND";
})(DataRetrievalFailureReason || (DataRetrievalFailureReason = {}));
export var DataUpdateFailurePatientActionNeededReason;
(function (DataUpdateFailurePatientActionNeededReason) {
    DataUpdateFailurePatientActionNeededReason["UNLOCKED_OR_NO_TARGETED_LIST"] = "UNLOCKED_OR_NO_TARGETED_LIST";
    DataUpdateFailurePatientActionNeededReason["MISSING_REFRESH_TOKENS"] = "MISSING_REFRESH_TOKENS";
    DataUpdateFailurePatientActionNeededReason["NEW_FACILITY_AUTHENTICATION_NEEDED"] = "NEW_FACILITY_AUTHENTICATION_NEEDED";
    DataUpdateFailurePatientActionNeededReason["UNABLE_TO_REFRESH_TOKENS"] = "UNABLE_TO_REFRESH_TOKENS";
    DataUpdateFailurePatientActionNeededReason["CONSENT_NOT_FOUND"] = "CONSENT_NOT_FOUND";
    DataUpdateFailurePatientActionNeededReason["CONSENT_EXPIRED"] = "CONSENT_EXPIRED";
    DataUpdateFailurePatientActionNeededReason["CONSENT_REVOKED"] = "CONSENT_REVOKED";
    DataUpdateFailurePatientActionNeededReason["NO_PREVIOUS_BATCH"] = "NO_PREVIOUS_BATCH";
})(DataUpdateFailurePatientActionNeededReason || (DataUpdateFailurePatientActionNeededReason = {}));
export class UpdateDocumentRetrievalTaskBatchInput {
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateDocumentRetrievalTaskBatchInput.prototype, "documentSelectionComplete", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateDocumentRetrievalTaskBatchInput.prototype, "skipLocationId", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateDocumentRetrievalTaskBatchInput.prototype, "excludedLocationIds", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateDocumentRetrievalTaskBatchInput.prototype, "patientHasDownloaded", void 0);
__decorate([
    IsEnum(DocumentVectorizationStatus),
    IsOptional(),
    __metadata("design:type", String)
], UpdateDocumentRetrievalTaskBatchInput.prototype, "documentVectorizationStatus", void 0);
export class DocumentRetrievalTEFCAInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTEFCAInput.prototype, "ial2IdToken", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalTEFCAInput.prototype, "ial2RefreshToken", void 0);
export class DocumentRetrievalTaskFastenInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTaskFastenInput.prototype, "connectionId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTaskFastenInput.prototype, "portalId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTaskFastenInput.prototype, "brandId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTaskFastenInput.prototype, "endpointId", void 0);
export class DocumentRetrievalTaskFacilitatedFHIRInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTaskFacilitatedFHIRInput.prototype, "documentId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTaskFacilitatedFHIRInput.prototype, "accessToken", void 0);
export var DocumentRetrievalLocationStatus;
(function (DocumentRetrievalLocationStatus) {
    DocumentRetrievalLocationStatus["NEEDS_AUTH"] = "NEEDS_AUTH";
    DocumentRetrievalLocationStatus["SKIPPED"] = "SKIPPED";
    DocumentRetrievalLocationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DocumentRetrievalLocationStatus["COMPLETE"] = "COMPLETE";
    DocumentRetrievalLocationStatus["ERROR"] = "ERROR";
})(DocumentRetrievalLocationStatus || (DocumentRetrievalLocationStatus = {}));
export var DocumentRetrievalTaskStatus;
(function (DocumentRetrievalTaskStatus) {
    DocumentRetrievalTaskStatus["RETRIEVING"] = "RETRIEVING";
    DocumentRetrievalTaskStatus["COMPLETE"] = "COMPLETE";
    DocumentRetrievalTaskStatus["ERROR"] = "ERROR";
})(DocumentRetrievalTaskStatus || (DocumentRetrievalTaskStatus = {}));
export var DocumentRetrievalAuthType;
(function (DocumentRetrievalAuthType) {
    DocumentRetrievalAuthType["IAS"] = "IAS";
    DocumentRetrievalAuthType["FASTEN"] = "FASTEN";
    DocumentRetrievalAuthType["FACILITATED_FHIR_EPIC"] = "FACILITATED_FHIR_EPIC";
    DocumentRetrievalAuthType["FACILITATED_FHIR_OTHER"] = "FACILITATED_FHIR_OTHER";
})(DocumentRetrievalAuthType || (DocumentRetrievalAuthType = {}));
export var DocumentRetrievalTaskSource;
(function (DocumentRetrievalTaskSource) {
    DocumentRetrievalTaskSource["MEDALLIES"] = "MEDALLIES";
    DocumentRetrievalTaskSource["COMMONWELL"] = "COMMONWELL";
    DocumentRetrievalTaskSource["FFHIR"] = "FFHIR";
    DocumentRetrievalTaskSource["FASTEN"] = "FASTEN";
    DocumentRetrievalTaskSource["HX_TEST"] = "HX_TEST";
})(DocumentRetrievalTaskSource || (DocumentRetrievalTaskSource = {}));
export var DocumentRetrievalTaskSourceType;
(function (DocumentRetrievalTaskSourceType) {
    DocumentRetrievalTaskSourceType["DOCUMENTS"] = "DOCUMENTS";
    DocumentRetrievalTaskSourceType["ENDPOINTS"] = "ENDPOINTS";
})(DocumentRetrievalTaskSourceType || (DocumentRetrievalTaskSourceType = {}));
export class DocumentRetrievalLocationMetadataBaseDto {
}
__decorate([
    IsEnum(DocumentRetrievalAuthType),
    __metadata("design:type", String)
], DocumentRetrievalLocationMetadataBaseDto.prototype, "authType", void 0);
export class DocumentRetrievalLocationMetadataIASDto {
    constructor() {
        this.authType = DocumentRetrievalAuthType.IAS;
    }
}
__decorate([
    IsEnum(DocumentRetrievalAuthType),
    __metadata("design:type", Object)
], DocumentRetrievalLocationMetadataIASDto.prototype, "authType", void 0);
export class DocumentRetrievalLocationMetadataFastenDto extends DocumentRetrievalLocationMetadataBaseDto {
    constructor() {
        super(...arguments);
        this.authType = DocumentRetrievalAuthType.FASTEN;
        this.organizationConnectionId = null;
    }
}
__decorate([
    IsEnum(DocumentRetrievalAuthType),
    __metadata("design:type", Object)
], DocumentRetrievalLocationMetadataFastenDto.prototype, "authType", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalLocationMetadataFastenDto.prototype, "organizationConnectionId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalLocationMetadataFastenDto.prototype, "portalId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalLocationMetadataFastenDto.prototype, "brandId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalLocationMetadataFastenDto.prototype, "endpointId", void 0);
export class DocumentRetrievalLocationMetadataFhirEpicDto {
    constructor() {
        this.authType = DocumentRetrievalAuthType.FACILITATED_FHIR_EPIC;
    }
}
__decorate([
    IsEnum(DocumentRetrievalAuthType),
    __metadata("design:type", Object)
], DocumentRetrievalLocationMetadataFhirEpicDto.prototype, "authType", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalLocationMetadataFhirEpicDto.prototype, "fhirEndpoint", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], DocumentRetrievalLocationMetadataFhirEpicDto.prototype, "myChartCentral", void 0);
export class DocumentRetrievalLocationMetadataFhirOtherDto {
    constructor() {
        this.authType = DocumentRetrievalAuthType.FACILITATED_FHIR_OTHER;
    }
}
__decorate([
    IsEnum(DocumentRetrievalAuthType),
    __metadata("design:type", Object)
], DocumentRetrievalLocationMetadataFhirOtherDto.prototype, "authType", void 0);
export function documentRetrievalLocationMetadataFromString(metadata) {
    if (!metadata)
        return null;
    try {
        const json = JSON.parse(metadata);
        switch (json.authType) {
            case DocumentRetrievalAuthType.IAS:
                return plainToInstance(DocumentRetrievalLocationMetadataIASDto, json);
            case DocumentRetrievalAuthType.FASTEN:
                return plainToInstance(DocumentRetrievalLocationMetadataFastenDto, json);
            case DocumentRetrievalAuthType.FACILITATED_FHIR_EPIC:
                return plainToInstance(DocumentRetrievalLocationMetadataFhirEpicDto, json);
            case DocumentRetrievalAuthType.FACILITATED_FHIR_OTHER:
                return plainToInstance(DocumentRetrievalLocationMetadataFhirOtherDto, json);
            default:
                return null;
        }
    }
    catch (error) {
        console.error(`Error parsing document retrieval location metadata ${JSON.stringify(metadata)} ${JSON.stringify(error)} `);
        return null;
    }
}
export function documentRetrievalLocationMetadataIASFromString(metadata) {
    if (!metadata)
        return null;
    const json = JSON.parse(metadata);
    return plainToInstance(DocumentRetrievalLocationMetadataIASDto, json);
}
export class DocumentRetrievalLocationDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalLocationDto.prototype, "id", void 0);
__decorate([
    IsEnum(DocumentRetrievalTaskSource),
    __metadata("design:type", String)
], DocumentRetrievalLocationDto.prototype, "source", void 0);
__decorate([
    IsEnum(DocumentRetrievalAuthType),
    __metadata("design:type", String)
], DocumentRetrievalLocationDto.prototype, "authType", void 0);
__decorate([
    IsEnum(DocumentRetrievalLocationStatus),
    __metadata("design:type", String)
], DocumentRetrievalLocationDto.prototype, "status", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalLocationDto.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalLocationDto.prototype, "organizationName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalLocationDto.prototype, "organizationLogoUrl", void 0);
__decorate([
    Type(() => Object, {
        discriminator: {
            property: "authType",
            subTypes: [
                { value: DocumentRetrievalLocationMetadataIASDto, name: DocumentRetrievalAuthType.IAS },
                { value: DocumentRetrievalLocationMetadataFastenDto, name: DocumentRetrievalAuthType.FASTEN },
                { value: DocumentRetrievalLocationMetadataFhirEpicDto, name: DocumentRetrievalAuthType.FACILITATED_FHIR_EPIC },
                { value: DocumentRetrievalLocationMetadataFhirOtherDto, name: DocumentRetrievalAuthType.FACILITATED_FHIR_OTHER },
            ],
        },
    }),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalLocationDto.prototype, "organizationMetadata", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalLocationDto.prototype, "isExcluded", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Date)
], DocumentRetrievalLocationDto.prototype, "updatedAt", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DocumentRetrievalLocationDto.prototype, "isPrevious", void 0);
export class CreateOrUpdateDocumentRetrievalLocationInput extends OmitType(DocumentRetrievalLocationDto, ["isPrevious"]) {
}
export class DocumentRetrievalTaskDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTaskDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], DocumentRetrievalTaskDto.prototype, "filename", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTaskDto.prototype, "locationId", void 0);
__decorate([
    IsEnum(DocumentRetrievalTaskSource),
    __metadata("design:type", String)
], DocumentRetrievalTaskDto.prototype, "source", void 0);
__decorate([
    IsEnum(DocumentRetrievalTaskStatus),
    __metadata("design:type", String)
], DocumentRetrievalTaskDto.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalTaskDto.prototype, "retrievalMetadata", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DocumentRetrievalTaskDto.prototype, "isPrevious", void 0);
export class CreateOrUpdateDocumentRetrievalTaskInput extends OmitType(DocumentRetrievalTaskDto, ["isPrevious"]) {
}
export class DocumentRetrievalTEFCADto {
}
__decorate([
    IsEnum(DocumentRetrievalTaskSource),
    __metadata("design:type", String)
], DocumentRetrievalTEFCADto.prototype, "source", void 0);
__decorate([
    IsEnum(DocumentRetrievalTaskSourceType),
    __metadata("design:type", String)
], DocumentRetrievalTEFCADto.prototype, "sourceType", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DocumentRetrievalTEFCADto.prototype, "isComplete", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalTEFCADto.prototype, "error", void 0);
__decorate([
    Type(() => DocumentRetrievalLocationMetadataIASDto),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalTEFCADto.prototype, "metadata", void 0);
export class DocumentRetrievalTaskBatchDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "batchId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "patientId", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Date)
], DocumentRetrievalTaskBatchDto.prototype, "createdAt", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalTaskBatchDto.prototype, "isDataUpdate", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], DocumentRetrievalTaskBatchDto.prototype, "allowOnlyTargetedFacilities", void 0);
__decorate([
    IsArray(),
    Type(() => DocumentRetrievalTEFCADto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], DocumentRetrievalTaskBatchDto.prototype, "tefcaQueries", void 0);
__decorate([
    IsArray(),
    Type(() => DocumentRetrievalLocationDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], DocumentRetrievalTaskBatchDto.prototype, "locations", void 0);
__decorate([
    IsArray(),
    Type(() => DocumentRetrievalTaskDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], DocumentRetrievalTaskBatchDto.prototype, "documents", void 0);
__decorate([
    IsArray(),
    Type(() => DocumentDeliveryDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], DocumentRetrievalTaskBatchDto.prototype, "documentDeliveries", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DocumentRetrievalTaskBatchDto.prototype, "documentSelectionComplete", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DocumentRetrievalTaskBatchDto.prototype, "finalized", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], DocumentRetrievalTaskBatchDto.prototype, "isAIFlow", void 0);
__decorate([
    IsEnum(DocumentVectorizationStatus),
    IsOptional(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "documentVectorizationStatus", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DocumentRetrievalTaskBatchDto.prototype, "patientHasDownloaded", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date),
    __metadata("design:type", Object)
], DocumentRetrievalTaskBatchDto.prototype, "patientDeliveryExpiration", void 0);
__decorate([
    IsEnum(PatientDataVisualizationPdfStatus),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalTaskBatchDto.prototype, "pdfStatus", void 0);
__decorate([
    Type(() => PatientDataVisualizationLiteDto),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalTaskBatchDto.prototype, "patientData", void 0);
__decorate([
    IsEnum(ContactMethod),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalTaskBatchDto.prototype, "patientContactMethod", void 0);
__decorate([
    IsEnum(DocumentVectorizationStatus),
    IsOptional(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationStatus", void 0);
__decorate([
    IsEnum(DocumentVectorizationStatus),
    IsOptional(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationIngestionStatus", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationKnowledgeBaseId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationVectorIndexName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDataSourceId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationIngestionJobId", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date),
    __metadata("design:type", Date)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationUpdatedAt", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDocumentsScanned", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDocumentsIndexed", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDocumentsModified", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDocumentsDeleted", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationDocumentsFailed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "vectorizationIngestionFailureReasons", void 0);
__decorate([
    IsEnum(DocumentRetrievalOrigin),
    __metadata("design:type", String)
], DocumentRetrievalTaskBatchDto.prototype, "origin", void 0);
export class DocumentRetrievalTaskDownloadDto {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalTaskDownloadDto.prototype, "errorMessage", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], DocumentRetrievalTaskDownloadDto.prototype, "downloadLink", void 0);
export class AWSDataDeliveryInfoDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AWSDataDeliveryInfoDto.prototype, "externalDataDeliveryRoleARN", void 0);
export class AuthorizeUrlInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthorizeUrlInput.prototype, "fhirEndpoint", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthorizeUrlInput.prototype, "redirectUrl", void 0);
__decorate([
    IsEnum(DocumentRetrievalAuthType),
    __metadata("design:type", String)
], AuthorizeUrlInput.prototype, "authType", void 0);
export class AuthorizeUrlDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthorizeUrlDto.prototype, "url", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthorizeUrlDto.prototype, "state", void 0);
export class GetFHIRRecordsInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], GetFHIRRecordsInput.prototype, "locationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], GetFHIRRecordsInput.prototype, "fhirEndpoint", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], GetFHIRRecordsInput.prototype, "redirectUri", void 0);
__decorate([
    IsEnum(DocumentRetrievalAuthType),
    __metadata("design:type", String)
], GetFHIRRecordsInput.prototype, "authType", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], GetFHIRRecordsInput.prototype, "code", void 0);
export class PatientTEFCAAuthInfoDto {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientTEFCAAuthInfoDto.prototype, "ial2Authorized", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientTEFCAAuthInfoDto.prototype, "ial2Expired", void 0);
